import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import InsuranceBatchFields from './InsuranceBatchFields'

export const InsuranceBatchCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list">
      <Grid container spacing={8}>
        <InsuranceBatchFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default InsuranceBatchCreate
